// extracted by mini-css-extract-plugin
export default {"container":"ProductLogo-module__container--FWEr9","logo":"ProductLogo-module__logo--aR506"};